/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Rectangle } from "src/classes/plate/lib/types";
import { CSSPositionOffsets } from "src/lib/types";

interface Args {
  anchor: Rectangle;
  dimensions: DOMRect;
  reversed: boolean;
}
export const borderControl = ({
  anchor,
  dimensions,
  reversed,
}: Args): { menuPosition: CSSPositionOffsets; shouldReverse: boolean } => {
  const menuPosition: { top?: number; left?: number; right?: number; bottom?: number } = {};
  let shouldReverse: boolean = reversed;
  if (anchor.top + dimensions.height > window.innerHeight) menuPosition.bottom = 0;
  else menuPosition.top = anchor.top - 1;

  if (reversed) {
    if (anchor.left - dimensions.width < 0) {
      menuPosition.left = anchor.right;
      shouldReverse = false;
    } else menuPosition.right = window.innerWidth - anchor.left;
  } else if (anchor.right + dimensions.width > window.innerWidth) {
    menuPosition.right = window.innerWidth - anchor.left;
    shouldReverse = true;
  } else menuPosition.left = anchor.right;

  return { menuPosition, shouldReverse };
};
